import { render, staticRenderFns } from "./DesignationView.vue?vue&type=template&id=6e54fe78&scoped=true"
import script from "./DesignationView.vue?vue&type=script&lang=js"
export * from "./DesignationView.vue?vue&type=script&lang=js"
import style0 from "./DesignationView.vue?vue&type=style&index=0&id=6e54fe78&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6e54fe78",
  null
  
)

export default component.exports